import { CHOICE_CONTROL_SIZE } from "./choice-control";
import { cn } from "./utils";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";
import * as React from "react";

const RadioGroup = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
    return <RadioGroupPrimitive.Root className={cn("gap-2 grid", className)} {...props} ref={ref} />;
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Item
            ref={ref}
            className={cn(
                CHOICE_CONTROL_SIZE,
                "disabled:opacity-50 border-2 border-indigo-600 dark:border-indigo-50 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-950 dark:focus-visible:ring-indigo-300 ring-offset-white focus-visible:ring-offset-2 dark:ring-offset-indigo-950 aspect-square text-indigo-600 dark:text-indigo-50 disabled:cursor-not-allowed",
                "flex items-center justify-center", // Add this line
                className
            )}
            {...props}
        >
            <RadioGroupPrimitive.Indicator className="flex justify-center items-center w-full h-full">
                <Circle className="fill-current text-current" />
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
    );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
